import React from "react";
import "./button.scss";

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string; // Text displayed on the button
  styleType?: "primary" | "outline" | "secondary"; // Style variations
  borderRadius?: string; // Custom border radius
  icon?: React.ReactNode; // Optional icon (e.g., SVG or font icon)
};

const Button: React.FC<ButtonProps> = ({
  label,
  styleType = "primary",
  borderRadius = "9999px",
  icon,
  className,
  ...rest
}) => {
  return (
    <button
      className={`button ${styleType} ${className || ''}`}
      style={{ borderRadius, ...(rest.style as object) }}
      {...rest}
    >
      {/* Icon support (if passed as prop) */}
      {icon && <span className="button-icon">{icon}</span>}
      {label}
    </button>
  );
};

export default Button;
